import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest } from 'utilities/service.utils';
import AppService from './app.service.context';

export const getWebLauncher = async (
  webLaunchRequestId: string,
  params?: any
) => {
  const urlBuilder = createUrlBuilder(
    `/system/weblaunchers/${webLaunchRequestId}`
  ).toString();

  return await getRequest(AppService, urlBuilder, params);
};
